const state = {
    hydro: []
}
const getters = {
    HYDRO: state => {
        return state.hydro;
    },
    HYDRO_B64_DATA: state => {
        let data = {};
        if (state.hydro.length) {
            data.firstName = state.hydro[0].firstName;
            data.lastName = state.hydro[0].lastName;
            data.jobTitle = state.hydro[0].jobTitle;
            data.company = state.hydro[0].company;
            data.date = state.hydro[0].date;
            data.agree = state.hydro[0].agree;
        }
        return btoa(JSON.stringify([data]));
    },
}
const mutations = {
    SET_HYDRO: (state, hydro) => {
        state.hydro = hydro;
    },
    ADD_HYDRO: (state, value) => {
        // re-init the array
        state.hydro = [];

        state.hydro.push(value);
    }
}
const actions = {
    SAVE_HYDRO: async (context, value) => {
        // save hydro info

        context.commit("ADD_HYDRO", value);
    }
}

export default {
    state, getters, mutations, actions
}